import React from 'react';

import { QuoteCardWithScoreImprovements } from '@marketing/components/testimonial_card';

import KellyHeadshot from './assets/kelly_headshot.png';
import MarcosHeadshot from './assets/marcos_headshot.png';

export default (props) => {
  return (
    <div className="d-flex flex-column flex-lg-row gap-m">
      <QuoteCardWithScoreImprovements
        scores={[
          { name: 'Percentile', score: '96th', scoreIncrease: '+13 Percentile Gain' }
        ]}
        studentAvatar={MarcosHeadshot}
        studentName="Marcos"
      >
        It is very friendly and easy to use.  Additionally, the explanations for every question are widely comprehensive and easy to follow. One more thing I loved is the different formats to study (quiz mode, practice mode, and practice exams).
      </QuoteCardWithScoreImprovements>

      <QuoteCardWithScoreImprovements
        scores={[
          { name: 'Percentile', score: '92nd', scoreIncrease: '+15 Percentile Gain' }
        ]}
        studentAvatar={KellyHeadshot}
        studentName="Kelly"
      >
        Magoosh’s videos are unparalleled, and the answer explanation videos helped me to identify patterns and shortcuts to improve my timing. Further, I loved the fact that the custom practice is adaptive, rather than being a mix of all questions.
      </QuoteCardWithScoreImprovements>
    </div>
  );
};
